import authConfig from '../components/auth/config/authConfig';
import { CAPTCHA_FIELDS } from '../constants/captchaConstants';
import { CaptchaProvider } from '../types/captcha';

export function getActiveCaptchaProvider(enableTurnstile?: boolean): CaptchaProvider {
    if (enableTurnstile !== undefined) {
        return enableTurnstile ? 'turnstile' : 'google';
    }

    const config = (window as any).authConfig || authConfig;
    return config.turnstileEnabled ? 'turnstile' : 'google';
}

export function getTurnstileSiteKey(): string {
    return process.env.MIX_TURNSTILE_SITE_KEY || '';
}

export function getGoogleV3SiteKey(): string {
    return process.env.MIX_CAPTCHA_V3_SITE_KEY || '';
}

export function getGoogleV2SiteKey(): string {
    return process.env.MIX_CAPTCHA_V2_SITE_KEY || '';
}

export function getCaptchaField(): string {
    return getActiveCaptchaProvider() === 'turnstile' ? CAPTCHA_FIELDS.TURNSTILE : CAPTCHA_FIELDS.GOOGLE_V2;
}
